<div class="container-fluid d-flex flex-column justify-content-center" style="background-color: #05cc7a;height:100vh;">
  <div class="d-flex flex-row justify-content-center">
    <div class="col-xs-10 col-sm-8 col-md-6 col-lg-5">
      <div class="row h-100 justify-content-center align-items-center">
        <div id="keycloak-loader"></div>
      </div>
    </div>
  </div>
</div>